/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Integration_Connect_ExpiredInputs */

const en_integration_connect_expired = /** @type {(inputs: Integration_Connect_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The ${i?.provider} connection request expired. Please try connecting again.`)
};

const es_integration_connect_expired = /** @type {(inputs: Integration_Connect_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La solicitud de conexión con ${i?.provider} caducó. Intenta conectarte de nuevo.`)
};

/**
* | output |
* | --- |
* | "The {provider} connection request expired. Please try connecting again." |
*
* @param {Integration_Connect_ExpiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const integration_connect_expired = /** @type {((inputs: Integration_Connect_ExpiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integration_Connect_ExpiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_integration_connect_expired(inputs)
	return en_integration_connect_expired(inputs)
});